import React, { useState } from "react";
import { db } from "../../../Components/Firebase";
import "../../Styles/Manager/Data/AddNewLayer.css";

function AddNewLayer({ onClose, schoolid }) {
    const [layerName, setLayerName] = useState("");

    const handleSave = async () => {
        if (layerName.trim()) {
            try {
                await db.collection("Schools").doc(schoolid).collection("Layers").add({
                    name: layerName,
                    createdAt: new Date(),
                });
                console.log("Layer added:", layerName);
                onClose();
            } catch (error) {
                console.error("Error adding layer: ", error);
            }
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>הוסף שכבה חדשה</h2>
                <input
                    type="text"
                    placeholder="שם השכבה"
                    value={layerName}
                    onChange={(e) => setLayerName(e.target.value)}
                    className="modal-input"
                />
                <div className="modal-actions">
                    <button className="modal-button cancel" onClick={onClose}>ביטול</button>
                    <button className="modal-button save" onClick={handleSave}>שמור</button>
                </div>
            </div>
        </div>
    );
}

export default AddNewLayer;
